import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledSidebar = styled(Layout.Sider)`
    &.ant-layout-sider {
        background-color: ${(props) => props.theme.semantic.surface};
    }

    &.ant-layout-sider-light {
        background: transparent;
    }

    .ant-layout-sider-children {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .ant-layout-sider-trigger {
        background: transparent;
        border-top: 1px solid ${(props) => props.theme.semantic.divider};
    }

    &.ant-layout-sider-collapsed {
        .ant-layout-sider-trigger {
            width: 80px;
        }
    }

    /* Logo container border bottom */
    .sidebar-logo {
        border-bottom: 1px solid ${(props) => props.theme.semantic.divider};
        padding: 12px 16px;
        box-sizing: border-box;
    }

    /* Border bottom for all menu items and groups */
    .ant-menu-item-group-list {
        border-bottom: 1px solid ${(props) => props.theme.semantic.divider};
    }

    /* Remove left padding from menu items */
    .ant-menu-item {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
        height: 56px;
        color: ${(props) => props.theme.semantic.textPrimary};
    }
    .ant-menu-title-icon {
        color: ${(props) => props.theme.semantic.textPrimary};
    }
    .ant-menu-title-content {
        color: ${(props) => props.theme.semantic.textPrimary};
    }

    :where(.ant-menu):not(.ant-menu-sub) > .ant-menu-item {
        border-bottom: 1px solid var(--color-divider);
        padding-bottom: 1.5rem !important;
        padding-top: 1.5rem !important;
        margin-top: 0px;
    }

    &.ant-layout-sider-collapsed .ant-menu-item {
        padding-right: 0 !important;
        padding-left: 1rem !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .ant-menu-light .ant-menu-item-selected {
        background-color: ${(props) => props.theme.semantic.primary} !important;
        color: ${(props) => props.theme.semantic.onPrimary} !important;
    }
    .ant-menu-light .ant-menu-item-selected > .ant-menu-title-content {
        color: ${(props) => props.theme.semantic.onPrimary} !important;
    }

    .ant-menu
        .ant-menu-item-group
        .ant-menu-item-group-list
        .ant-menu-submenu-title {
        padding-left: 1rem !important;
    }
    .ant-menu-submenu-title {
        padding-left: 0.8rem !important;
        color: ${(props) => props.theme.semantic.textPrimary} !important;
    }
    .ant-menu-inline .ant-menu-sub.ant-menu-inline {
        padding-left: 1rem !important;
    }

    .ant-menu-submenu.ant-menu-submenu-inline > .ant-menu-submenu-title {
        border-radius: unset;
        height: 48px;
        border-bottom: 1px solid ${(props) => props.theme.semantic.divider};
    }
`;
